import useEmblaCarousel from "embla-carousel-react";
import { useCallback, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarDays,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
// import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { useRouter } from "next/router";
interface HomeSlidesParams {
  slides: HomeSlideParams[];
}
export interface HomeSlideParams {
  title: string;
  subtitle: string;
  description: string;
  backgroundImage: string;
  sideImage: string;
  button?: {
    buttonText: string;
    buttonHref: string;
    buttonHrefExternal?: boolean;
  };
}
const HomeSlide: React.FC<HomeSlideParams> = ({
  title,
  subtitle,
  description,
  backgroundImage,
  sideImage,
  button = { buttonText: "", buttonHref: "", buttonHrefExternal: false },
}) => {
  const router = useRouter();

  const isExternal = button.buttonHrefExternal ?? false;

  return (
    <div className="flex flex-grow-0 flex-shrink-0 basis-full">
      <div className="w-full h-full flex items-center gap-16 py-16 md:px-32 px-24 absolute top-0 z-10 bg-darkBlue bg-opacity-70">
        <div className="w-full md:w-1/2 flex flex-col gap-5">
          <h1 className="text-3xl md:text-5xl font-bold text-white -mb-2">
            {title}
          </h1>
          <h1 className="text-base md:text-lg font-bold text-white">
            {subtitle}
          </h1>
          <h1 className="text-base md:text-lg text-white text-justify">
            {description}
          </h1>
          {button && (
            <button
              className="w-fit bg-defaultBlue p-3 text-white font-bold rounded-md hover:bg-darkBlue"
              onClick={() => {
                if (isExternal) {
                  window.open(button.buttonHref, "_blank", "noreferrer");
                } else {
                  router.push(button.buttonHref);
                }
              }}
            >
              {button.buttonText}
            </button>
          )}
        </div>
        <div className="hidden md:block w-1/2 h-96 -mr-12">
          <img
            className="w-full h-full object-contain"
            alt=""
            src={sideImage}
          />
        </div>
      </div>
      <img className="w-full object-cover" alt="" src={backgroundImage} />
    </div>
  );
};


interface TitleSlideProps {
  comingSoon?: boolean;
}

const TitleSlide: React.FC<TitleSlideProps> = ({ comingSoon = false }) => {
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  return (
        <div className="flex flex-grow-0 flex-shrink-0 basis-full">
              <div className="flex flex-col absolute top-0 z-10 bg-darkBlue w-full h-full bg-opacity-70 px-16 sm:px-20 md:px-24 py-6 sm:py-10 md:py-16 items-center justify-center gap-2.5 sm:gap-4 md:gap-5">
                <div className="flex flex-col items-center gap-2 sm:gap-4 md:gap-10 md:flex-row justify-center w-full">

                    <div className="md:w-96 md:h-96 flex flex-col items-center text-white text-center justify-center">
                        <img className="object-contain -mt-2 md:-mt-6 w-48 sm:w-56 md:w-96 h-auto md:h-96" src="/images/title-2026.png" />
                        <h1 className="font-light md:text-s lg:hidden">Scratch Coding Game · Competitive Programming · Innovative Technology Challenge · EcoQuest AI Web Application</h1>
                    </div>
                    <div className="flex flex-col gap-5 max-w-lg items-center justify-center md:items-start">

                        <div className="flex flex-col items-center text-white text-center md:items-start md:text-start">
                            <h1 className="text-sm font-light md:text-xl lg:text-2xl mb-4">For Elementary, Junior High School, Senior High School, and University Students.</h1>

                            <div className="flex items-center justify-center md:justify-start">
                                <h1 className="font-semibold text-sm md:text-base lg:text-lg text-center md:text-left">
                                    <FontAwesomeIcon icon={faCalendarDays} className='mr-1.5 text-xs md:text-base text-white inline-block' />
                                    Online Preliminary Submission - 29.11.2026
                                </h1>
                            </div>
                            <div className="flex items-center justify-center md:justify-start">
                                <h1 className="font-semibold text-sm md:text-base lg:text-lg text-center md:text-left">
                                    <FontAwesomeIcon icon={faCalendarDays} className='mr-1.5 text-xs md:text-base text-white inline-block' />
                                    Online Preliminary Live Competition Competitive Programming - 5.12.2026
                                </h1>
                            </div>
                            <div className="flex items-center justify-center md:justify-start">
                                <h1 className="font-semibold text-sm md:text-base lg:text-lg text-center md:text-left">
                                    <FontAwesomeIcon icon={faCalendarDays} className='mr-1.5 text-xs md:text-base text-white inline-block' />
                                    Onsite Final Round - 12.12.2026
                                </h1>
                            </div>


                        </div>
                        <ul className="list-disc text-white text-base lg:text-lg ml-5 md:block hidden">
                            <li>Scratch Coding Game</li>
                            <li>Competitive Programming</li>
                            <li>Innovative Technology Challenge</li>
                            <li>EcoQuest AI Web Application</li>
                        </ul>
                        <div className="flex flex-col gap-1">
                          <div className="md:text-xl lg:text-2xl text-white md:text-start text-center">
                              Cash Prizes & Educational Benefits
                          </div>
                          <ul className="list-disc text-white text-base lg:text-md ml-5 md:block hidden">
                            <li>Apply for the Widia Scholarship (Full Scholarship for Up to 4 Years of Study at BINUS University)</li>
                            <li>Community Service (Comserv) Hours for BINUSIAN</li>
                            <li>2-Month Online Full Stack Developer Bootcamp</li>
                        </ul>
                      </div>
                    </div>
                    
                </div>
                <button className="w-fit bg-defaultBlue p-3 text-white font-bold rounded-md hover:bg-darkBlue" onClick={()=>openInNewTab("https://link.accelist.com/RegisterIIT2026")}>Register Now!</button>
                <h1 className="text-white text-center text-[11px] sm:text-xs md:text-base max-w-xl">Grand Winners will have the opportunity to contribute directly to addressing real needs in village communities through technology and innovation</h1>
            </div>


            <img className="w-full object-cover" src="/images/tech-bg.jpg" />
        </div>
    )

  // return (
  //   <div className="flex flex-grow-0 flex-shrink-0 basis-full">
  //     <div className="flex flex-col absolute top-0 z-10 bg-darkBlue w-full h-full bg-opacity-70 px-20  py-16 items-center gap-5">
  //       {/* Overlay utama */}
  //       {/* <div className={`flex flex-col absolute top-0 z-10 w-full h-full px-20 py-16 items-center gap-5 transition-all duration-300
  //               ${comingSoon ? "bg-black/70 backdrop-blur-sm" : "bg-darkBlue/70"}
  //           `}> */}
  //       {/* Coming Soon Mode */}
  //       {comingSoon ? (
  //         <div className="flex flex-col h-full items-center justify-center text-center text-white gap-16">
  //           <div className="flex flex-col items-center justify-center gap-0 text-white uppercase">
  //             <p className="text-slate-300 text-2xl md:text-3xl">
  //               Indonesia Innovative Technology
  //             </p>
  //             <p className="text-[10rem] md:text-[12rem] leading-none font-bold -mt-4 md:-mt-6">
  //               IIT
  //             </p>
  //             <p className="text-slate-300 text-2xl md:text-3xl">
  //               Competition 2026
  //             </p>
  //           </div>
  //           <div className="flex flex-col gap-4">
  //             <h1 className="text-gray-400 text-4xl md:text-6xl font-bold tracking-wide uppercase">
  //               Coming Soon
  //             </h1>
  //             <p className="text-gray-400 text-lg md:text-xl">
  //               Stay tuned for updates and registration details!
  //             </p>
  //           </div>
  //         </div>
  //       ) : (
  //         <>
  //           {/* Normal Mode */}
  //           <div className="flex flex-col items-center gap-5 md:gap-10 md:flex-row justify-center w-full">
  //             <div className="md:w-96 md:h-96 flex flex-col items-center text-white text-center justify-center">
  //               <img
  //                 className="object-contain md:h-96 mt-6 w-64 md:w-96"
  //                 alt=""
  //                 src="/images/IIT_noBG.png"
  //               />
  //               <h1 className="font-light text-base md:text-xs md:hidden">
  //                 Software Programming - Academic Writing & Presentation - Robot
  //                 Race
  //               </h1>
  //             </div>
  //             <div className="flex flex-col gap-5 max-w-lg items-center justify-center md:items-start">
  //               <div className="flex flex-col items-center text-white text-center md:items-start md:text-start">
  //                 <h1 className="text-xs font-light md:text-xl lg:text-2xl mb-3">
  //                   For Elementary, Junior High, and Senior High
  //                 </h1>

  //                 <div className="flex items-center">
  //                   <FontAwesomeIcon
  //                     icon={faCalendarDays}
  //                     className="mr-2"
  //                     style={{ fontSize: "1.5rem", color: "white" }}
  //                   />
  //                   <h1 className="font-semibold md:text-2xl lg:text-3xl">
  //                     07 Februari 2026{" "}
  //                   </h1>
  //                 </div>
  //                 {/* <div className="flex items-center">
  //                                   <FontAwesomeIcon icon={faLocationDot} className='mr-2' style={{ fontSize: "1.5rem", color: 'white' }} />
  //                                       <h1 className="font-semibold md:text-2xl lg:text-3xl whitespace-nowrap">Genesis Global Community School Scholarship</h1>
  //                                   </div>    */}
  //               </div>
  //               <ul className="list-disc text-white text-xl lg:text-2xl ml-5 md:block hidden whitespace-nowrap">
  //                 <li>Python Coding</li>
  //                 <li>Scratch Coding</li>
  //                 <li>Duel in Vibe Coding</li>
  //                 <li>Innovative Technology Challenge</li>
  //                 <li>Student Symposium Research Paper</li>
  //                 <li>Design Dash - Mobile UI/UX Quest</li>
  //               </ul>
  //               <div className="text-sm md:text-xl lg:text-2xl text-white md:text-start text-center ">
  //                 Education Prizes Equivalent to{" "}
  //                 <span className="font-bold text-red-500">Rp.216.825.000</span>
  //               </div>
  //             </div>
  //           </div>
  //           <button
  //             className="w-fit bg-defaultBlue p-3 text-white font-bold rounded-md hover:bg-darkBlue"
  //             onClick={() =>
  //               openInNewTab("http://link.accelist.com/DaftarIITxGenesis2025")
  //             }
  //           >
  //             Register Now!
  //           </button>
  //           <h1 className="text-white  text-center text-xs md:text-base max-w-xl">
  //             The winners will become Indonesia&apos;s representative in the
  //             World Innovative Technology (WIT) Challenge on 2-3 November 2024
  //             at Chonnam National University, Yeosu-si, South Korea
  //           </h1>
  //         </>
  //       )}
  //     </div>

  //     {/* Background */}
  //     <img className="w-full object-cover" alt="" src="/images/tech-bg.jpg" />
  //   </div>
  // );
};

const HomeSlides: React.FC<HomeSlidesParams> = ({ slides }) => {
  const slidesWithTitle = [
    {
      title: "",
      subtitle: "",
      description: "",
      backgroundImage: "",
      sideImage: "",
    },
    ...slides,
  ];
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    watchDrag: false,
  });
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

  const scrollPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi]);

  const scrollTo = useCallback(
    (index: number) => {
      emblaApi?.scrollTo(index);
    },
    [emblaApi],
  );

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    setScrollSnaps(emblaApi.scrollSnapList());
    emblaApi.on("select", onSelect);
    onSelect();
  }, [emblaApi, onSelect]);

  useEffect(() => {
    if (!emblaApi) return;

    const interval = setInterval(() => {
      emblaApi.scrollNext();
    }, 10000);

    return () => clearInterval(interval);
  }, [emblaApi]);

  return (
    <div className="relative w-full mx-auto overflow-hidden">
      {/* Carousel viewport */}
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex h-[700px]">
          {slidesWithTitle.map((slide, index) => {
            if (index === 0) {
              return <TitleSlide key={index} />;
            }
            return (
              <HomeSlide
                key={index}
                title={slide.title}
                subtitle={slide.subtitle}
                description={slide.description}
                backgroundImage={slide.backgroundImage}
                sideImage={slide.sideImage}
                button={slide.button}
              />
            );
          })}
        </div>
      </div>
      <button
        className="absolute w-10 h-10 flex justify-center items-center text-white bg-defaultBlue hover:bg-dark focus:ring-darkBlue dark:bg-defaultBlue dark:hover:bg-darkBlue dark:focus:ring-defaultBlue left-4 top-1/2 -translate-y-1/2 rounded-full p-2 shadow"
        onClick={scrollPrev}
      >
        <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: "1.25rem" }} />
      </button>
      <button
        className="absolute w-10 h-10 flex justify-center items-center text-white bg-defaultBlue hover:bg-dark focus:ring-darkBlue dark:bg-defaultBlue dark:hover:bg-darkBlue dark:focus:ring-defaultBlue right-4 top-1/2 -translate-y-1/2 rounded-full p-2 shadow"
        onClick={scrollNext}
      >
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{ fontSize: "1.25rem" }}
        />
      </button>
      <div className="hidden md:flex justify-center gap-2 mt-4 absolute z-10 bottom-3 left-1/2 -translate-x-1/2">
        {scrollSnaps.map((_, index) => (
          <button
            key={index}
            onClick={() => scrollTo(index)}
            className={`w-3 h-3 rounded-full transition-all ${
              index === selectedIndex
                ? "bg-defaultBlue scale-110"
                : "bg-gray-300 hover:bg-gray-400"
            }`}
          />
        ))}
      </div>
    </div>
  );
};
export default HomeSlides;
